import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-upgrade-prompt-modal',
  templateUrl: './upgrade-prompt-modal.component.html',
  styleUrl: './upgrade-prompt-modal.component.css'
})
export class UpgradePromptModalComponent {
  @Input() additionalCost: number;
  @Input() upgradeFeatures: string[] = [];
  @Input() triggerMessage: string = 'Upgrade to access this feature.';
  @Input() noUpgradeAvailable: boolean = false;

  constructor(private dialogRef: DialogRef) {}

  onConfirm(): void {
    if (!this.noUpgradeAvailable) {
      this.dialogRef.close('confirm');
    }
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
